import React from 'react';
import A, { AnchorProps } from '@sls-react/components/Links/A';
import { Link } from '@sls-react/routing';

type Props = AnchorProps & {
  type: 'terms' | 'privacy' | 'accessibility';
};

const TermsLink: React.FC<Props> = ({ children, type, ...props }) => (
  <Link href={`/${type}`} passHref prefetch={false}>
    <A {...props} rel="nofollow noindex">
      {children}
    </A>
  </Link>
);

export default TermsLink;
